/**
 * Unified GraphQL Queries Export
 * Central export point for all organized GraphQL queries
 */

// Import all query collections
import { PATIENT_QUERIES } from './patientsGquery';
import { SEARCH_QUERIES } from './searchGquery';
import { GROUPS_QUERIES } from './groupsGquery';
import { CLINICS_QUERIES } from './clinicsGquery';
import { STATUS_QUERIES } from './statusGquery';
import { USERS_QUERIES } from './usersGquery';
import { APPOINTMENTS_QUERIES } from './appointmentsGquery';
import { NOTIFICATIONS_QUERIES } from './notificationsGquery';
import { MISC_QUERIES } from './miscGquery';
import { SMS_QUERIES } from './smsGquery';
import { WEBSOCKET_SUBSCRIPTIONS } from './webSocketQueries';

// Unified export object combining all queries
export const GRAPHQL_RESOURCES = {
  // Patient-related queries
  ...PATIENT_QUERIES,
  
  // Search functionality
  ...SEARCH_QUERIES,
  
  // Group management
  ...GROUPS_QUERIES,
  
  // Clinics and facilities
  ...CLINICS_QUERIES,
  
  // Status mapping
  ...STATUS_QUERIES,
  
  // Users and specialists
  ...USERS_QUERIES,
  
  // Appointments and scheduling
  ...APPOINTMENTS_QUERIES,
  
  // Notifications and communication
  ...NOTIFICATIONS_QUERIES,
  
  // Miscellaneous queries
  ...MISC_QUERIES,

  // SMS queries
  ...SMS_QUERIES,

  // WebSocket subscriptions for real-time updates
  ...WEBSOCKET_SUBSCRIPTIONS
};

// Individual exports for specific use cases
export {
  PATIENT_QUERIES,
  SEARCH_QUERIES,
  GROUPS_QUERIES,
  CLINICS_QUERIES,
  STATUS_QUERIES,
  USERS_QUERIES,
  APPOINTMENTS_QUERIES,
  NOTIFICATIONS_QUERIES,
  MISC_QUERIES,
  SMS_QUERIES,
  WEBSOCKET_SUBSCRIPTIONS
};

// Default export
export default GRAPHQL_RESOURCES;